function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-heart-empty",
  "data-name": "Icon ionic-ios-heart-empty",
  d: "M20.913,3.938h-.058a6.564,6.564,0,0,0-5.481,3,6.564,6.564,0,0,0-5.481-3H9.837a6.523,6.523,0,0,0-6.462,6.519,14.043,14.043,0,0,0,2.758,7.656,48.327,48.327,0,0,0,9.242,8.9,48.327,48.327,0,0,0,9.242-8.9,14.043,14.043,0,0,0,2.758-7.656A6.523,6.523,0,0,0,20.913,3.938Zm2.4,13.223a44.25,44.25,0,0,1-7.938,7.823,44.316,44.316,0,0,1-7.938-7.829,12.446,12.446,0,0,1-2.446-6.7,4.895,4.895,0,0,1,4.858-4.9H9.9a4.837,4.837,0,0,1,2.371.623,5.041,5.041,0,0,1,1.754,1.644,1.621,1.621,0,0,0,2.712,0A5.092,5.092,0,0,1,18.49,6.182a4.837,4.837,0,0,1,2.371-.623h.052a4.895,4.895,0,0,1,4.858,4.9A12.6,12.6,0,0,1,23.313,17.161Z",
  transform: "translate(-3.375 -3.938)",
  fill: "#313136"
});

var SvgHeart20 = function SvgHeart20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23.077,
    viewBox: "0 0 24 23.077",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-20.345d232e.svg";
export { ForwardRef as ReactComponent };